<template>
	<v-card class="fill-height">
		<v-card-title>
			<h3 class="headline font-weight-bold">Create User</h3>
		</v-card-title>

		<router-view></router-view>
	</v-card>
</template>

<script>
export default {
	data() {
		return {};
	},
};
</script>
